import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { Props as SpecialIndexProps } from "scmp-app/components/content/content-item-render/variants/special-index";
import { getContentTypeName } from "scmp-app/components/content/helpers";
import type { specialIndexTagContent$key } from "scmp-app/queries/__generated__/specialIndexTagContent.graphql";

import { getFallbackLink } from "./helpers";
import { useTag } from "./hooks";
import { StyledAnchor, StyledTag, StyledTagEntityLink } from "./styles";

type Props = {
  reference: specialIndexTagContent$key;
  variant: SpecialIndexProps["variant"];
};

export const SpecialIndexTag: FunctionComponent<Props> = ({ reference, variant }) => {
  const content = useFragment(
    graphql`
      fragment specialIndexTagContent on Content {
        ...helpersGetContentTypeNameContent
        ...hooksSpecialIndexContent
        topics {
          ...entityLink
        }
      }
    `,
    reference,
  );

  const contentTypeName = getContentTypeName(content);

  const fallbackLink = getFallbackLink(contentTypeName);

  const tag = useTag({ contentTypeName, reference: content, variant });

  switch (variant) {
    case "series":
      return <StyledTag>{tag}</StyledTag>;
    default:
      if (content.topics && content.topics[0]) {
        return <StyledTagEntityLink reference={content.topics[0]}>{tag}</StyledTagEntityLink>;
      }

      if (fallbackLink) {
        return <StyledAnchor href={fallbackLink}>{tag}</StyledAnchor>;
      }

      return <StyledTag>{tag}</StyledTag>;
  }
};

SpecialIndexTag.displayName = "SpecialIndexTag";
